import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, ZapIcon } from 'lucide-react';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="offer" ref={ref} className="relative w-full py-24 md:py-32 px-4 bg-bg-secondary overflow-hidden" data-id="element-173">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent-green/10 rounded-full blur-3xl pointer-events-none" data-id="element-174" />

      <div className="relative max-w-4xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-176">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-green/10 border border-accent-green/30 mb-6" data-id="element-177">
            <ZapIcon className="w-4 h-4 text-accent-green" data-id="element-178" />
            <span className="text-accent-green font-semibold text-sm" data-id="element-179">
              LIMITED TIME OFFER
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-180">
            Get The Complete System{' '}
            <span className="text-accent-green" data-id="element-181">Today</span>
          </h2>
        </motion.div>

        {/* Main Offer Card */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="glass-card rounded-3xl p-8 md:p-12 border border-accent-green/20 glow-green" data-id="element-182">
          {/* Product Image */}
          <div className="flex justify-center mb-8" data-id="element-183">
            <div className="relative" data-id="element-184">
              <div className="absolute inset-0 animate-hero-glow rounded-2xl" data-id="element-185" />
              <img src="https://cdn.magicpatterns.com/uploads/fMjjuNvA9y6j4GiJz7cGRR/heylloyd-image-1772303912052.png" alt="The Anonymous Asset System" className="relative w-64 md:w-80 rounded-2xl" data-id="element-186" />
            </div>
          </div>

          {/* Price */}
          <div className="text-center mb-8" data-id="element-187">
            <div className="text-text-muted line-through text-lg mb-2" data-id="element-188">
              Regular Price: $19.99
            </div>
            <div className="flex items-center justify-center gap-3" data-id="element-189">
              <span className="text-6xl md:text-7xl font-black text-accent-green" data-id="element-190">
                $6.39
              </span>
              <span className="text-text-muted text-lg" data-id="element-191">one-time</span>
            </div>
            <p className="text-accent-cyan mt-2 font-semibold" data-id="element-192">
              Save 68% Today
            </p>
          </div>

          {/* What's Included */}
          <div className="mb-8" data-id="element-193">
            <h3 className="text-lg font-semibold text-white mb-4 text-center" data-id="element-194">
              What's Included:
            </h3>
            <div className="grid md:grid-cols-2 gap-3" data-id="element-195">
              {['Anonymous Asset Blueprint', '0% Face Framework', 'H.A.L.O. Retention Formula', 'AI Creative Stack', '3-Variable Profit Rule', '7-Day Launch Plan'].map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-196">
                  <CheckIcon className="w-5 h-5 text-accent-green flex-shrink-0" data-id="element-197" />
                  <span className="text-text-light" data-id="element-198">{item}</span>
                </div>)}
            </div>
          </div>

          {/* CTA Button */}
          <div id="offer-cta" className="text-center" data-id="element-199">
            <a href="https://ecoviewdigital.com/cart/51901370925343:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-accent-green text-bg-primary font-bold text-lg md:text-xl uppercase tracking-wide px-8 md:px-12 py-4 md:py-5 rounded-lg animate-pulse-glow hover:scale-105 transition-transform duration-300" data-id="element-200">
              GET ASSETS NOW
            </a>
            <p className="text-text-muted text-sm mt-4" data-id="element-201">
              Instant PDF Download • Lifetime Access
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}